<div class="admin-layout" [class.sidebar-collapsed]="isSidebarCollapsed">
  <aside class="sidebar" [class.collapsed]="isSidebarCollapsed">
    <div class="sidebar-header">
      <h2 *ngIf="!isSidebarCollapsed">Admin</h2>

      <button type="button" class="toggle-btn" (click)="toggleSidebar()">
        <mat-icon aria-hidden="true">{{ isSidebarCollapsed ? 'menu' : 'close' }}</mat-icon>
      </button>
    </div>

    <nav class="sidebar-menu">
      <a routerLink="/admin/categories" routerLinkActive="active">
        <mat-icon class="icon" aria-hidden="true">category</mat-icon>
        <span *ngIf="!isSidebarCollapsed">Kategori & Seri</span>
      </a>
      <a routerLink="/admin/products" routerLinkActive="active">
        <mat-icon class="icon" aria-hidden="true">inventory_2</mat-icon>
        <span *ngIf="!isSidebarCollapsed">Produk</span>
      </a>

      <a routerLink="/admin/wall" routerLinkActive="active">
        <mat-icon class="icon" aria-hidden="true">texture</mat-icon>
        <span *ngIf="!isSidebarCollapsed">Dinding</span>
      </a>

      <a routerLink="/admin/floor" routerLinkActive="active">
        <mat-icon class="icon" aria-hidden="true">grid_view</mat-icon>
        <span *ngIf="!isSidebarCollapsed">Lantai</span>
      </a>

      <a routerLink="/admin/ceiling" routerLinkActive="active">
        <mat-icon class="icon" aria-hidden="true">roofing</mat-icon>
        <span *ngIf="!isSidebarCollapsed">Ceiling</span>
      </a>

      <a routerLink="/admin/backsplash" routerLinkActive="active">
        <mat-icon class="icon" aria-hidden="true">window</mat-icon>
        <span *ngIf="!isSidebarCollapsed">Backsplash</span>
      </a>

      <a routerLink="/admin/templates" routerLinkActive="active">
        <mat-icon class="icon" aria-hidden="true">image</mat-icon>
        <span *ngIf="!isSidebarCollapsed">Foto Template</span>
      </a>
      <a routerLink="/admin/companies" routerLinkActive="active">
        <mat-icon class="icon" aria-hidden="true">business</mat-icon>
        <span *ngIf="!isSidebarCollapsed">Perusahaan</span>
      </a>
    </nav>

    <button type="button" class="logout-btn" (click)="logout()">
      <mat-icon class="icon" aria-hidden="true">logout</mat-icon>
        <span *ngIf="!isSidebarCollapsed">Keluar</span>
    </button>
  </aside>
  <div class="main-content" >
      <div class="button-navigate">
        <button (click)="navigateToVisualizer()">Studio Visualizer</button>
      </div>
      <main class="content">
        <router-outlet></router-outlet>
      </main>
  </div>
</div>
